import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * Product Routes and Pages
 */
const ListQuotePage = React.lazy(() => import("./ListQuotePage"));
const ViewQuotePage = React.lazy(() => import("./ViewQuotePage"));
const QuoteRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListQuotePage />} />
      <Route exact path="/view/:id" element={<ViewQuotePage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default QuoteRoutes;
